/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancellationFeedbackResource } from '../models/CancellationFeedbackResource'
import type { CancellationFeedbackStore } from '../models/CancellationFeedbackStore'

import type { CancelablePromise } from '../core/CancelablePromise'
import type { BaseHttpRequest } from '../core/BaseHttpRequest'

export class CancellationService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * Get a list of cancellation feedback with optional date filtering.
     * @returns any OK
     * @throws ApiError
     */
    public getCancellationFeedbacks({
        startDate,
        endDate
    }: {
        /**
         * Filter by start date
         */
        startDate?: string
        /**
         * Filter by end date
         */
        endDate?: string
    }): CancelablePromise<{
        data: Array<CancellationFeedbackResource>
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/cancellation',
            query: {
                start_date: startDate,
                end_date: endDate
            },
            errors: {
                401: `User is unauthorized.`,
                403: `Access Denied`
            }
        })
    }

    /**
     * Store a new cancellation feedback record.
     * @returns void
     * @throws ApiError
     */
    public createCancellationFeedback({
        requestBody
    }: {
        requestBody: CancellationFeedbackStore
    }): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/cancellation',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                401: `User is unauthorized.`,
                403: `Access Denied`
            }
        })
    }

    /**
     * Show details of a specific cancellation feedback record.
     * @returns any OK
     * @throws ApiError
     */
    public getCancellationFeedback({
        id
    }: {
        /**
         * ID of the retrieved resource.
         */
        id: number
    }): CancelablePromise<{
        data: CancellationFeedbackResource
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/cancellation/{id}',
            path: {
                id: id
            },
            errors: {
                401: `User is unauthorized.`,
                403: `Access Denied`,
                404: `Not Found`
            }
        })
    }

    /**
     * Update the churn flag for a cancellation feedback record.
     * @returns any OK
     * @throws ApiError
     */
    public updateCancellationFeedback({
        id,
        requestBody
    }: {
        /**
         * ID of the retrieved resource.
         */
        id: number
        requestBody: {
            /**
             * Update churn flag for the cancellation feedback.
             */
            is_churn?: boolean
        }
    }): CancelablePromise<{
        data: CancellationFeedbackResource
    }> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/cancellation/{id}',
            path: {
                id: id
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                401: `User is unauthorized.`,
                403: `Access Denied`,
                404: `Not Found`
            }
        })
    }

    /**
     * Get statistics of cancellation feedback.
     * Retrieve statistics of cancellation feedback, including reasons and most frequent trends.
     * @returns void
     * @throws ApiError
     */
    public getCancellationsStatistics({
        startDate,
        endDate
    }: {
        /**
         * Filter cancellations from this start date (optional).
         */
        startDate?: string
        /**
         * Filter cancellations up to this end date (optional).
         */
        endDate?: string
    }): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/cancellations/statistics',
            query: {
                start_date: startDate,
                end_date: endDate
            },
            errors: {
                401: `User is unauthorized.`,
                403: `Access Denied`
            }
        })
    }
}
